import { buildBlogBaseUrl, buildGetAuthorUrl, buildGetCatgoriesUrl, buildGetCatgoryUrl, buildGetPostUrl, buildGetPostsUrl } from "~/helpers/blog";
import type { BlogCategory, BlogPost } from "~/types";

interface GetPostsOptions {
  category?: number; author?: number; perPage?: number; exclude?: BlogPost['id']; search?: string;
}

export default function useWordpress() {
  const { blog } = useBranch();
  if (!blog) {
    throw createError({
      status: 404,
      message: 'No WP url to this branch/domain: ' + useNuxtApp().$domain
    });
  }
  const baseUrl = buildBlogBaseUrl(blog);

  return {
    getPosts(options: GetPostsOptions = {}) {
      const url = buildGetPostsUrl(baseUrl, options);
      return $fetch<BlogPost[]>(url);
    },

    getPost(slug: string) {
      return $fetch<BlogPost[] | null>(buildGetPostUrl(baseUrl, slug));
    },

    getCategories() {
      return $fetch<BlogCategory[]>(buildGetCatgoriesUrl(baseUrl));
    },

    getCatgory(slug: string) {
      return $fetch<BlogCategory[]>(buildGetCatgoryUrl(baseUrl, slug));
    },

    getAuthor(id: string) {
      return $fetch(buildGetAuthorUrl(baseUrl, id));
    }
  };
}